/* ── Section Animations — IntersectionObserver class toggle ──
   Toggles `.is-visible` on `.animate-on-scroll` elements.
   Disabled entirely when animation_level=none or prefers-reduced-motion. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.body.dataset.animationLevel === 'none') return;

  var targets = document.querySelectorAll('.animate-on-scroll');
  if (!targets.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  targets.forEach(function (el) { observer.observe(el); });
})();
